import React, { useEffect, useState } from "react";

import { Account } from "src/types/accounts";
import { ExpandableToggle } from "../../components/expandableToggle";

import _ from "lodash";
import styles from "./styles.module.scss";

interface AssetSettingsProps {
  data: Partial<Account>;
  handleAccountSettingsUpdate: (value: any) => void;
}

const AssetSettings: React.FC<AssetSettingsProps> = ({ data, handleAccountSettingsUpdate }) => {

  const [contentSettings, setContentSettings] = useState({
    expireContent: false,
  });

  const handleToggleChange = (value: boolean) => {
    const updatedSettings = {
      ...contentSettings,
      expireContent: value,
    };

    setContentSettings(updatedSettings);
    handleAccountSettingsUpdate(updatedSettings);
  };

  useEffect(() => {
    if (data?.contentSettings) {
      setContentSettings(prev => ({ ...prev, ...data.contentSettings }));
    }
  }
  , [data?.contentSettings]);

  return (
    <div className={styles.container}>
      <div className={styles.toggleRow}>
      <ExpandableToggle
        id="restrict-expired-assets"
        title="Restrict Expired Assets"
        description="Automatically restrict the sharing of your expired assets."
        value={contentSettings.expireContent}
        onChange={handleToggleChange}
        collapsible={true}
        helpText={
          <span className={styles.helpText}>
            <i className="fa fa-exclamation-triangle" />
            Important: This will remove access to expired content for all previous recipients. They'll no longer be able to view these assets.
          </span>
        }
      />
      </div>
    </div>
  );
};


export default AssetSettings;